import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {SortTableCellTitleDescription} from '../../../../../shared/models/sort-table/cell-classes';
import {BaseCellComponent} from '../_base-cell/base-cell.component';
import {PillComponent} from '../../../pill/pill.component';

@Component({
  selector: 'motn-sort-table-cell-title-description',
  template: `
    @if (hasCustomHtml()) {
      <div [innerHTML]="getCustomHtml()"></div>
    } @else {
      <div
        class="title"
        [innerText]="cell.title"
      ></div>
      @if (!cell.descriptionIsPill) {
        <div
          class="description"
          [innerText]="cell.description"
        ></div>
      } @else {
        <motn-pill
          [squareLetter]="cell.descriptionPillLetter"
        >{{ cell.description }}</motn-pill>
      }
    }
  `,
  styleUrls: ['./sort-table-cell-title-description.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    PillComponent,
  ],
})
export class SortTableCellTitleDescriptionComponent extends BaseCellComponent implements OnInit {
  @Input() cell: SortTableCellTitleDescription;


  constructor() {
    super();
  }


  protected onInit(): void {
  }

  hasCustomHtml(): boolean {
    return !!(this.cell as any).customHtml;
  }

  getCustomHtml(): string {
    return (this.cell as any).customHtml || '';
  }

}
